import type { FaireProductEntity } from "../../entity_types/product";

export const p_8zg7k62a83: FaireProductEntity = {
  token: "p_8zg7k62a83",
  type: "product",
  name: "Plain Striped Wool Scarf Soft Warm Winter Neck Wrap",
  brandToken: "b_5qb9p6vh8d",
  brandName: "SALINA TRADING INC",
  imageUrl:
    "https://cdn.faire.com/fastly/4775b6bd810cbeec3c5ce189ab225c96d6828d0a465654e8e136ab39d32457e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfe8a89fba203f62f409d377e058ba55104f746f33aa13907ef3106b5316fe68.jpeg",
    "https://cdn.faire.com/fastly/c1a877b8a46e5e3ab7139a8f04dfce3b38e197258d6f080a9df1fac200cf16af.jpeg",
    "https://cdn.faire.com/fastly/ab50eb1feafb32a703fe4560eda3ceac6409d71cd7768401a134181adc472c96.jpeg",
    "https://cdn.faire.com/fastly/025e7fcf90adee5d68d806e55aa44e3fc1868f9eb305c31552ed16aa6ba35e84.jpeg",
    "https://cdn.faire.com/fastly/981f65365940f14b1d0ed97db7fceb41dfb6de6b9958bac65a01ef58d1fbd3e3.jpeg",
    "https://cdn.faire.com/fastly/3146e272c7118ec0e67b01eca4a0dfc5a1351c4b363333f352dc87f5b9d66cbc.jpeg",
    "https://cdn.faire.com/fastly/07d80059c3380fdc10e9135c7c55544768c046b2123c5316de1b53d2743a58dd.jpeg",
    "https://cdn.faire.com/fastly/1f38eb785a18d13ec824512a1bc8d5c73e4b6e60a016e45e64cc0c632b964ad3.jpeg",
    "https://cdn.faire.com/fastly/f45e367b6c0378788b3a346f6118f015a2ca5c5a2df58c252b70f4cf944f9879.jpeg",
    "https://cdn.faire.com/fastly/5747b0b74abc9b034bcb035e7fed99805eb71c4af3d01e849d23ec25f7d2f5cf.jpeg",
    "https://cdn.faire.com/fastly/22d6ea218a3a3d94aad83063039b6917af98a8d8ca43c2746198311ad1e0aece.jpeg",
    "https://cdn.faire.com/fastly/0c4932f8f1402dd157a7b5150da00ef2fb00733fc51244705d0edf477de35173.jpeg",
    "https://cdn.faire.com/fastly/44d0f871016adb13ea36be6377870bf22573f48567e8d732446086352b7978b9.jpeg",
  ],
  priceDollars: 19.25,
  description:
    "This luxurious scarf is crafted from 100% pure Australian wool, ensuring a soft and warm feel for the winter season. With a stylish striped design, it adds a trendy touch to any outfit.\n\nFeatures:\n - Material: 100% Australian Wool\n - Dimensions: 160 x 20 cm\n - Care Instructions: Hand wash or dry clean only\n - Available Colors: Black, Red, Coffee, Khaki, Green, Pumpkin, Light Gray, Black Gray, Pink Camel\n\n\nThis versatile scarf is perfect for layering and can be styled for both casual and formal occasions. Its chic design makes it a must-have accessory for your winter wardrobe.\n",
  tags: [],
  msrpDollars: 38.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:53.194Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
